module.exports = __webpack_public_path__ + "img/snapchat.10e5ad79.svg";